import Words from '../../data/words.json';

export const ValidateWord = (word) => {
    const validWords = Words;
    console.log(validWords);
    return validWords.includes(word); // Check if word is in the list
};

export const ValidateLength = (word) => {
    return word.length === 5;
};

export const ValidateEqualWords = (word, mainword) => {
    return word.toLowerCase() === mainword.toLowerCase();
}



